<div class="remote-select">
  <div class="input-group">
    <input #select (click)="onClick()" (blur)="onExit($event)" (change)="onChange($event)" [(ngModel)]="inputValue" (keyup)="onChange($event)" type="search" class="form-control" placeholder="" aria-label="Username" aria-describedby="basic-addon1">
    @if (isLoading) {
      <div>{{'sale4all.label.loading' | translate}}</div>
    }
    @if (expanded&&(!isLoading)) {
      <div id="options">
        @for (opt of dataList; track opt) {
          <option (click)="selectValue(opt)" [value]="opt">{{opt.label}}</option>
        }
      </div>
    }
  </div>
</div>
